<template>
  <div class="page" :class="{ 'page--with-merge': hasPayoutLinesInList }">
    <van-nav-bar title="门店支出单" fixed placeholder>
      <template #right>
        <span class="nav-action" @click="showFilter = true">筛选</span>
      </template>
    </van-nav-bar>
      <div class="pay-mode-bar">
      <span
          class="pay-mode-bar__opt"
          :class="{ 'pay-mode-bar__opt--active': !isHeadquarterPay }">月底结</span>
          <van-switch v-model="isHeadquarterPay" active-color="#1989fa" size="22px" @change="fetchList"/>
          <span class="pay-mode-bar__opt" :class="{ 'pay-mode-bar__opt--active': isHeadquarterPay }">总部打款</span>
      </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="list-body">
        <van-loading v-if="loading" class="list-body__loading" type="spinner" vertical>
          加载中...
        </van-loading>
        <van-empty v-else-if="!error && list.length === 0" description="暂无数据" />
        <div v-else-if="error" class="list-body__err" @click="fetchList">
          请求失败，点击重试
        </div>
        <van-checkbox-group v-else v-model="selectedLineKeys">
          <div
            v-for="item in list"
            :key="item.sysbillid"
            class="bill-card"
            @click="goDetail(item.approval.sysbillid)"
          >
            <div class="bill-card__row bill-card__row--emph">
              <span class="muted">门店</span>
              <span class="bill-card__strong">{{ item.approval.storename || '—' }}</span>
            </div>
            <div class="bill-card__row bill-card__row--emph">
              <span class="muted">账务日期</span>
              <span class="bill-card__strong">{{ item.approval.accountdate || '—' }}</span>
            </div>
              <div class="bill-card__row bill-card__row--emph">
                  <span class="muted">支出类型</span>
                  <span class="bill-card__strong">{{showOuttypes[item.approval.billtype-1].name}}</span>
              </div>
            <div class="bill-card__lines-block" @click.stop>
              <div class="bill-card__lines-title">支出明细</div>
              <template>
                <div
                  v-for="(line, idx) in item.approvalDetals"
                  :key="line.id"
                  class="bill-card__line">
                  <div class="bill-card__line-check" @click.stop>
                    <van-checkbox :name="lineSelectKey(item,line,idx)" />
                  </div>
                  <div class="bill-card__line-body">
                    <div class="bill-card__line-main">
                      <span class="bill-card__line-desc">{{ line.itemname || '—' }}</span>
                      <span class="bill-card__line-amt">¥{{ formatAmount(line.amount) }}</span>
                    </div>
                    <div class="bill-card__line-payee">
                      <div class="bill-card__line-payee-row">
                        <span class="bill-card__payee-lbl">收款姓名</span>
                        <span class="bill-card__payee-val">{{ displayText(line.detal1) }}</span>
                      </div>
                      <div class="bill-card__line-payee-row">
                        <span class="bill-card__payee-lbl">收款账户</span>
                        <span class="bill-card__payee-val bill-card__payee-val--account">{{
                          displayText(line.detal2)
                        }}</span>
                      </div>
                      <div class="bill-card__line-payee-row">
                        <span class="bill-card__payee-lbl">开户行</span>
                        <span class="bill-card__payee-val">{{ displayText(line.detal3) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="bill-card__foot" @click.stop="goDetail(item.approval.sysbillid)">
              <span>查看详情</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </van-checkbox-group>
      </div>
    </van-pull-refresh>

    <div v-if="hasPayoutLinesInList" class="merge-bar">
      <div class="merge-bar__left">
        <van-checkbox v-model="allSelected">全选</van-checkbox>
        <span class="merge-bar__hint">已选 {{ selectedLineKeys.length }} 条</span>
      </div>
      <van-button
        type="primary"
        size="small"
        class="merge-bar__btn"
        :disabled="selectedLineKeys.length === 0"
        @click="onMergePay"
      >
        合并打款
      </van-button>
    </div>

    <merge-payment-dialog
      v-model="showMergeDialog"
      :summary="mergeSummary"
      :line-items="mergeDialogLineItems"
      :submitting="mergeSubmitting"
      @confirm="onMergePaymentConfirm"
    />

    <van-popup
      v-model="showFilter"
      position="bottom"
      round
      :style="{ height: '52%' }"
      class="filter-popup"
    >
      <div class="filter-popup__title">筛选条件</div>
      <van-cell-group inset>
        <van-field
          readonly
          clickable
          label="门店"
          :value="storeText"
          placeholder="请选择门店"
          @click="showStorePicker = true"
        />
        <van-field
          readonly
          clickable
          label="账务日期"
          :value="dateRangeText"
          placeholder="选择日期范围"
          @click="showCalendar = true"
        />
      </van-cell-group>
      <div class="filter-popup__actions">
        <van-button block plain type="default" @click="resetDraft">重置</van-button>
        <van-button block type="primary" native-type="button" @click="applyFilter">查询</van-button>
      </div>
    </van-popup>

    <van-calendar
      v-model="showCalendar"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      allow-same-day
      @confirm="onCalendarConfirm"
    />

    <van-popup v-model="showStorePicker" position="bottom" round class="store-picker-popup" get-container="body">
        <div class="store-picker-shell">
              <van-picker
                show-toolbar
                title="选择门店"
                :columns="storeColumns"
                @cancel="showStorePicker = false"
                @confirm="onStoreConfirm"
              />
        </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import MergePaymentDialog from '../../components/MergePaymentDialog.vue'

export default {
    name: 'MpayoutList',
    components: {MergePaymentDialog},
    data() {
        return {
            isHeadquarterPay: true,
            list: [],
            loading: false,
            refreshing: false,
            error: false,
            showFilter: false,
            showCalendar: false,
            showStorePicker: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(),
            dateRange: [],
            query: {
                storeid: localStorage.getItem("storeid"),
                fromdate: "",
                todate: ""
            },
            draft: {
                storeid: ''
            },
            /** 对接后端时可改为接口返回的 { text, value } 列表 */
            storeColumns: [],
            selectedLineKeys: [],
            showMergeDialog: false,
            mergeSubmitting: false,
            mergeSummary: {
                storeid: '',
                lineCount: 0,
                totalText: 0.00
            },
            pendingMergeRows: [],
            showOuttypes:[
                {id:1,name:"门店支出"},
                {id:2,name:"员工奖励"},
                {id:3,name:"医药费"},
                {id:4,name:"总部开支"},
                {id:5,name:"总部收入"},
                {id:6,name:"菜金"},
                {id:7,name:"产品打款"},
            ],
        }
    },
    computed: {
        dateRangeText() {
            if (this.dateRange && this.dateRange.length === 2) {
                return `${this.dateRange[0]} ~ ${this.dateRange[1]}`
            }
            return ''
        },
        storeText() {
            const col = this.storeColumns.find((c) => c.value === this.draft.storeid)
            return col ? col.text : ''
        },
        allLineKeysInList() {
            const keys = []
            for (const item of this.list) {
                const lines = this.payoutLinesOf(item)
                lines.forEach((line, idx) => {
                    keys.push(this.lineSelectKey(item, line, idx))
                })
            }
            return keys
        },
        hasPayoutLinesInList() {
            return this.allLineKeysInList.length > 0
        },
        allSelected: {
            get() {
                const keys = this.allLineKeysInList
                return keys.length > 0 && keys.every((k) => this.selectedLineKeys.includes(k))
            },
            set(checked) {
                this.selectedLineKeys = checked ? [...this.allLineKeysInList] : []
            }
        },
        mergeDialogLineItems() {
            return (this.pendingMergeRows || []).map((r) => {
                const line = r.line || {}
                return {
                    id: line.id,
                    paycontont: line.itemname,
                    amount: line.amount,
                    receName: line.detal1,
                    receAccount: line.detal2,
                    receBank: line.detal3
                }
            })
        }
    },
    watch: {
        showFilter(val) {
            if (val) {
                this.draft = {storeid: this.query.storeid}
            }
        }
    },
    mounted() {
        this.fetchList();
        this.getStoreInfoByStructsOpen();
    },
    methods: {
        getStoreInfoByStructsOpen() {
            this.storeColumns = [];
            let storeid = localStorage.getItem("storeid");
            this.$post("store/getStoreInfoByStructsOpen", {storeid: storeid}).then(res => {
                if (res.sucess) {
                    let obj = res.object;
                    for (let val of obj) {
                        this.storeColumns.push({text: val.brandname, value: val.brandid});
                    }
                }
            });
        },
        fmtDate(d) {
            const x = new Date(d)
            const y = x.getFullYear()
            const m = String(x.getMonth() + 1).padStart(2, '0')
            const day = String(x.getDate()).padStart(2, '0')
            return `${y}-${m}-${day}`
        },
        onCalendarConfirm(dates) {
            this.showCalendar = false
            if (dates && dates.length === 2) {
                this.dateRange = [this.fmtDate(dates[0]), this.fmtDate(dates[1])]
            }
        },
        pickPickerValue(value) {
            let v = Array.isArray(value) ? value[0] : value
            if (v && typeof v === 'object' && 'value' in v) {
                v = v.value
            }
            return v
        },
        onStoreConfirm(value) {
            this.showStorePicker = false
            this.draft.storeid = this.pickPickerValue(value)
        },
        resetDraft() {
            this.draft = {storeid: localStorage.getItem("storeid")}
            this.dateRange = []
        },
        applyFilter() {
            this.query = {
                storeid: (this.draft.storeid || '').trim()
            }
            this.showFilter = false
            this.fetchList()
        },
        async fetchList(opts) {
            let type=1;
            if(this.isHeadquarterPay){
                type=2;
            }
            let fromdate="";
            let todate="";
            if(this.dateRange!=null && this.dateRange.length>0){
                fromdate=this.dateRange[0];
                todate=this.dateRange[1];
            }
            this.list = [];
            this.$post("/payout/getApprovalStorePayOut", {
                storeid: this.query.storeid,
                fromdate: fromdate,
                todate: todate,
                type:type
            }).then(res => {
                if (res.sucess) {
                    if (res.object != null) {
                        this.list = res.object;
                    }
                }
            });
        },
        async onRefresh() {
            await this.fetchList();
            this.refreshing = false
        },
        goDetail(sysbillid) {
            this.$router.push({name: 'MpayoutDetail', params: {sysbillid}})
        },
        lineSelectKey(item, line, idx) {
            const bill = item && item.approval.sysbillid != null ? String(item.approval.sysbillid) : ''
            const lid =
                line && line.id != null && line.id !== '' ? String(line.id) : `i${idx}`
            return `${bill}@@${lid}`
        },
        collectSelectedPayoutRows() {
            const rows = []
            for (const item of this.list) {
                const lines = this.payoutLinesOf(item)
                lines.forEach((line, idx) => {
                    const k = this.lineSelectKey(item, line, idx)
                    if (this.selectedLineKeys.includes(k)) {
                        rows.push({
                            sysbillid: item.sysbillid,
                            line,
                            billStoreId: item.storeid
                        })
                    }
                })
            }
            return rows
        },
        resolveStoreIdFromSelected(rows) {
            const first = rows[0]
            const fromLine =
                first.line && first.line.storeid != null
                    ? String(first.line.storeid).trim()
                    : ''
            if (fromLine) return fromLine
            return first.billStoreId != null ? String(first.billStoreId).trim() : ''
        },
        getStoreName(storeid){
            let storename="";
            for(let val of this.storeColumns){
                if(storeid==val.value){
                    storename=val.text;
                    break;
                }
            }
            return storename;
        },
        onMergePay() {
            const selected = this.collectSelectedPayoutRows()
            if (!selected.length) {
                Toast('请选择要打款的明细')
                return
            }
            const storeCheck = this.assertSameStoreForMergeRows(selected)
            if (!storeCheck.ok) {
                Toast.fail(storeCheck.message)
                return
            }
            if (selected.some(({line}) => line.id == null)) {
                Toast.fail('明细缺少 id，无法生成打款单')
                return
            }
            let total = 0
            for (const {line} of selected) {
                const n = Number(line.amount)
                if (Number.isFinite(n)) total += n
            }

            let storename=this.getStoreName(selected[0].line.storeid);
            this.pendingMergeRows = selected
            this.mergeSummary = {
                storeid: this.resolveStoreIdFromSelected(selected),
                storename:storename,
                lineCount: selected.length,
                totalText: total.toFixed(2)
            }
            this.showMergeDialog = true
        },
        async onMergePaymentConfirm(form) {
            const rows = this.pendingMergeRows
            if (!rows.length) return
            const storeid = this.resolveStoreIdFromSelected(rows)
            if (!storeid) {
                Toast.fail('无法确定门店')
                return
            }
            const lines = rows.map((r) => r.line)
            this.mergeSubmitting = true
            try {
                const payload = buildMergePaymentPayload(storeid, lines, form)
                const res = await createMergePayment(payload)
                const {orderid, paymentmoutdetal} = parseMergePaymentResult(res)
                const n = paymentmoutdetal.length
                Toast.success(
                    orderid != null
                        ? `已生成打款主档（id：${orderid}）及 ${n} 条打款明细`
                        : '打款单已提交'
                )
                this.showMergeDialog = false
                this.selectedLineKeys = []
            } catch (e) {
                Toast.fail(
                    (e.response && e.response.data && e.response.data.message) || '提交失败'
                )
            } finally {
                this.mergeSubmitting = false
            }
        },
        /** 列表接口可返回 payoutLines / lines / payouts */
        payoutLinesOf(item) {
            if (!item) return []
            return item.approvalDetals || []
        },
        displayText(v) {
            if (v === null || v === undefined || String(v).trim() === '') return '—'
            return String(v)
        },
        formatAmount(v) {
            if (v === null || v === undefined || v === '') return '—'
            const n = Number(v)
            return Number.isFinite(n) ? n.toFixed(2) : String(v)
        },
        assertSameStoreForMergeRows(rows) {
            if (!rows || rows.length <= 1) return {ok: true}
            const resolve = (r) => {
                const fromLine = this.normalizeStoreId(r.line && r.line.storeid)
                if (fromLine !== '') return fromLine
                return this.normalizeStoreId(r.billStoreId)
            }
            const base = resolve(rows[0])
            for (let i = 1; i < rows.length; i++) {
                if (resolve(rows[i]) !== base) {
                    return {
                        ok: false,
                        message: '所选明细门店不一致，无法合并打款'
                    }
                }
            }
            return {ok: true}
        },
        normalizeStoreId(v) {
            if (v === null || v === undefined) return ''
            return String(v).trim()
        },
    }
}
</script>

<style scoped>
.page {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  background: #f7f8fa;
}
.page--with-merge {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}
.nav-action {
  font-size: 14px;
  color: #1989fa;
  padding: 0 4px;
}
.list-body {
  min-height: 40vh;
}
.list-body__loading {
  padding: 48px 0;
}
.list-body__err {
  padding: 48px 16px;
  text-align: center;
  color: #ee0a24;
  font-size: 14px;
}
.bill-card {
  margin: 10px 12px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.bill-card__row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.6;
  margin-top: 4px;
  gap: 12px;
}
.bill-card__row--emph {
  margin-top: 8px;
  font-size: 14px;
}
.bill-card__strong {
  font-weight: 600;
  color: #323233;
  text-align: right;
  word-break: break-all;
}
.bill-card__row span:last-child {
  text-align: right;
  word-break: break-all;
}
.bill-card__lines-block {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebedf0;
}
.bill-card__lines-title {
  font-size: 12px;
  color: #969799;
  margin-bottom: 8px;
}
.bill-card__line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f2f3f5;
  font-size: 13px;
}
.bill-card__line-check {
  flex-shrink: 0;
  padding-top: 2px;
}
.bill-card__line-body {
  flex: 1;
  min-width: 0;
}
.bill-card__line:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.bill-card__line-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
.bill-card__line-desc {
  flex: 1;
  min-width: 0;
  color: #323233;
  line-height: 1.45;
  word-break: break-word;
}
.bill-card__line-amt {
  flex-shrink: 0;
  font-weight: 600;
  color: #ee0a24;
}
.bill-card__line-payee {
  margin-top: 8px;
  padding: 8px 8px 6px;
  background: #f7f8fa;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.45;
}
.bill-card__line-payee-row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}
.bill-card__line-payee-row:last-child {
  margin-bottom: 0;
}
.bill-card__payee-lbl {
  flex-shrink: 0;
  width: 4.5em;
  color: #969799;
}
.bill-card__payee-val {
  flex: 1;
  min-width: 0;
  color: #323233;
  word-break: break-word;
}
.bill-card__payee-val--account {
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: normal;
}
.bill-card__no-lines {
  font-size: 13px;
  padding: 4px 0 2px;
}
.muted {
  color: #969799;
  flex-shrink: 0;
}
.bill-card__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #ebedf0;
  font-size: 13px;
  color: #1989fa;
}
.filter-popup__title {
  padding: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
.filter-popup__actions {
  display: flex;
  gap: 10px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
}
.merge-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
}
.merge-bar__left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.merge-bar__hint {
  font-size: 13px;
  color: #646566;
}
.merge-bar__btn {
  flex-shrink: 0;
}

.pay-mode-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 10px 16px;
    background: #fff;
    border-bottom: 1px solid #ebedf0;
}
.pay-mode-bar__opt {
    font-size: 14px;
    color: #969799;
    min-width: 4.5em;
    text-align: center;
}
.pay-mode-bar__opt--active {
    color: #323233;
    font-weight: 600;
}
</style>
<style>
.store-picker-popup .store-picker-shell {
    max-width: 480px;
    margin: 0 auto;
    box-sizing: border-box;
}
@media (min-width: 768px) {
    .store-picker-popup .van-picker__toolbar {
        user-select: none;
    }
    .store-picker-popup .van-picker-column {
        touch-action: pan-y;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/headpayout/MpayoutList.vue